import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import VueCookies from 'vue-cookies';
Vue.use(VueLocalStorage)
Vue.use(VueCookies);

const TOKEN_KEY = 'access_token'
const REFERRAL_CODE = 'referralCode'
const COUNTRY = 'country'
const LANGUAGE = 'language'
/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
const TokenService = {
  getToken() {
    return $cookies.isKey(TOKEN_KEY) ? $cookies.get(TOKEN_KEY) : ''
    //return Vue.localStorage.get(TOKEN_KEY)
  },

  saveToken(accessToken) {
    Vue.localStorage.set(TOKEN_KEY, accessToken)
    $cookies.set(TOKEN_KEY, accessToken, "30d") //1 Month
  },

  removeToken() {
    Vue.localStorage.remove(TOKEN_KEY)
    $cookies.remove(TOKEN_KEY);
  },

  saveUTM(key, value) {
    $cookies.set(key, value, "30d") //1 Month
  },

  getUTM(key) {
    return $cookies.isKey(key) ? $cookies.get(key) : ""
  }
}
const ReferralService = {
  getReferral() {
    return Vue.localStorage.get(REFERRAL_CODE)
  },

  saveReferral(code) {
    Vue.localStorage.set(REFERRAL_CODE, code)
  },

  removeToken() {
    Vue.localStorage.remove(REFERRAL_CODE)
  }
}

const LanguageService = {
  getLanguage() {
    return JSON.parse(Vue.localStorage.get(LANGUAGE))
  },

  saveLanguage(language) {
    Vue.localStorage.set(LANGUAGE, JSON.stringify(language))
  },

  removeLanguage() {
    Vue.localStorage.remove(LANGUAGE)
  }
}

const CountryService = {
  getCountry() {
    return JSON.parse(Vue.localStorage.get(COUNTRY))
  },

  saveCountry(country) {
    Vue.localStorage.set(COUNTRY, JSON.stringify(country))
  },

  removeCountry() {
    Vue.localStorage.remove(COUNTRY)
  }
}
export { TokenService, LanguageService, CountryService, ReferralService }



// WEBPACK FOOTER //
// ./src/services/storage.service.js